import { useRef, useEffect } from 'react';
import type { LogEntry } from '../../../contexts/LogContext';

const LOG_COLORS: Record<string, string> = {
  step: 'text-[#58a6ff]',
  ok: 'text-[#3fb950]',
  err: 'text-[#f85149]',
  info: 'text-[#8b949e]',
  warn: 'text-[#d29922]',
};

type LogPanelProps = {
  logs: LogEntry[];
};

export const LogPanel = ({ logs }: LogPanelProps) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [logs]);

  return (
    <div
      ref={containerRef}
      className="bg-[#010409] border border-[#30363d] rounded-lg p-3 font-mono text-xs leading-7 max-h-[500px] overflow-y-auto whitespace-pre-wrap break-all"
    >
      {logs.length === 0 ? (
        <span className="text-[#8b949e]">Log output will appear here...</span>
      ) : (
        logs.map((entry, i) => (
          <span key={i} className={`block ${LOG_COLORS[entry.type] || ''}`}>
            {entry.message}
          </span>
        ))
      )}
    </div>
  );
};
